import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const included = [
  'Every feature, no tiers',
  'Free updates forever',
  'No subscription, no account',
];

const Pricing = () => {
  const headerRef = useScrollAnimation();
  const cardRef = useScrollAnimation();
  const trustRef = useScrollAnimation();

  return (
    <section id="pricing" className="relative py-20 lg:py-28">
      {/* Spectral glow */}
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute bottom-[-10rem] left-1/2 -translate-x-1/2 w-[40rem] h-[26rem] bg-spectral/15 rounded-full blur-[140px]"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div ref={headerRef} className="text-center mb-14 animate-slide-up">
          <span className="eyebrow">Pricing</span>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-bone mt-4 mb-5">
            Pay once. Haunt forever.
          </h2>
          <p className="text-lg lg:text-xl text-mist max-w-2xl mx-auto">
            One small payment, lifetime access. No subscription hiding in the fine print.
          </p>
        </div>

        {/* Pricing Card */}
        <div className="flex justify-center">
          <div ref={cardRef} className="card-capture p-8 lg:p-12 max-w-md w-full animate-scale-in !border-phantom/25">
            {/* Price */}
            <div className="text-center mb-8">
              <div className="flex items-baseline justify-center gap-3 mb-3">
                <span className="font-display text-6xl lg:text-7xl font-bold text-bone">
                  $9.99
                </span>
                <span className="font-mono text-xl text-mist line-through">
                  $14.99
                </span>
              </div>
              <div className="inline-flex items-center gap-2 font-mono text-xs text-phantom border border-dashed border-phantom/40 rounded-full px-4 py-1.5">
                one-time payment · lifetime access
              </div>
            </div>

            {/* Included */}
            <ul className="space-y-3.5 mb-9">
              {included.map((item) => (
                <li key={item} className="flex items-center gap-3">
                  <span className="font-mono text-phantom text-sm">✓</span>
                  <span className="text-bone/90">{item}</span>
                </li>
              ))}
            </ul>

            {/* CTA */}
            <button
              onClick={() => window.open('https://checkout.dodopayments.com/buy/pdt_54TFptJsGToLhXUMmCpdC?quantity=1', '_blank')}
              className="btn-primary w-full text-lg font-bold"
            >
              Get Ghost Text — $9.99
            </button>
          </div>
        </div>

        {/* Trust Indicators */}
        <div ref={trustRef} className="text-center mt-10 animate-slide-up">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-8 font-mono text-xs text-mist">
            <span>Secure checkout</span>
            <span className="hidden sm:block w-1 h-1 bg-mist/50 rounded-full"></span>
            <span>Your data never leaves your Mac</span>
            <span className="hidden sm:block w-1 h-1 bg-mist/50 rounded-full"></span>
            <span>Lifetime updates</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
